import { TblSortDir } from '../table.types';

export function cssSortByIcon(sort: TblSortDir): string {
    switch (sort) {
        case 'ASC':
            return 'icon-glyph icon-asc';
        case 'DSC':
            return 'icon-glyph icon-dsc';
        default:
            return 'icon-glyph icon-width-0';
    }
}
